import { render, staticRenderFns } from "./Referrer.vue?vue&type=template&id=09c9129d&scoped=true"
import script from "./Referrer.vue?vue&type=script&lang=js"
export * from "./Referrer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c9129d",
  null
  
)

export default component.exports